import React from 'react';
import { AppRouter } from './routes';
import { AuthProvider } from './context/authContext';
import { SessionProvider } from './context/SessionContext';
import { EstadoAppProvider } from './context/EstadoAppContext';
import { GeoProvider } from './context/GeoContext';
import { NuevaONGProvider } from './context/NuevaONGContext';
import { FormProvider } from './context/FormContext';
import { ReferentesProvider } from './context/ReferentesContext';
import { ThemeProvider } from './context/ThemeContext';

import './App.css';
import 'react-toastify/dist/ReactToastify.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import GeocodingOverlay from './components/GeocodingOverlay';

const queryClient = new QueryClient();

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <SessionProvider>
            <EstadoAppProvider>
              <GeoProvider>
                <NuevaONGProvider>
                  <ReferentesProvider>
                    <FormProvider>
                      <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-200">
                        <AppRouter />
                        <GeocodingOverlay />
                      </div>                    
                    </FormProvider>
                  </ReferentesProvider>
                </NuevaONGProvider>
              </GeoProvider>
            </EstadoAppProvider>
          </SessionProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
